namespace('compass.hotel');

compass.requireLib('compass.util.format');
compass.requireLib('compass.util.parse');

compass.hotel.AffiliateAvailableRoomListWidget = compass.defineWidget(function AffiliateAvailableRoomListWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = $j.dom;
	var _settings = options;
	var _shortDate = compass.util.dateFormatter('mmm dd');
	var _fullDate = compass.util.dateFormatter('mmmm dd, yyyy');

	function _formatShortDate(label, dateStr) {
		var date = compass.util.parse.ISODateParser(dateStr);
		return d.span(label,
			d.abbr({ title : _fullDate(date) }, _shortDate(date))
		);
	}

	function _handleSelectButtonClosure(roomData){
		var roomDataClosure = roomData;
		return function(clickevt){
			me.trigger('AffiliateAvailableRoomListWidget.roomSelected', { roomdata : roomDataClosure });
		};
	}
	
	function _handleViewRoomInfoClick(roomData) {
		var roomDataClosure = roomData;
		return function(clickevt) {
			me.trigger('AffiliateAvailableRoomListWidget.viewRoomInfoClicked', { roomdata : roomDataClosure });
		};
	}

	this.render = function(widgetElem) {
		var currencyCode = _settings.meetingInfo.currencyCode;
		var cf = compass.util.currencyFormatter(currencyCode, { showDecimals : 0, returnAsObject: true });

		var roomsCountLabel = _settings.roomsCount + ' room' + (_settings.roomsCount != 1 ? 's' : '');
		var occupancyLabel = _settings.occupancyLabels[_settings.searchCriteria.occupancy];
		var arriveLabel = _formatShortDate('Check-in: ', _settings.searchCriteria.arrive);
		var departLabel = _formatShortDate('Check-out: ', _settings.searchCriteria.depart);

		var rooms_list = _settings.epsAvail.rooms;
		var has_fee_disclaimer = rooms_list.length > 0 && rooms_list[0].fees > 0;

		// sort rooms from lowest rate to highest rate, then by name A-Z for ties, then expedia collect first if there's still a tie
		var sorted_rooms = _.chain(rooms_list).sortBy(function(room) {
			return room.merchant_of_record;
		}).sortBy(function(room) {
			return room.roomName;
		}).sortBy(function(room) {
			return room.avgRate + room.fees;
		}).value();

		widgetElem.append(d.div({ className : 'roomListContainer' },
			d.div({ className : 'backLink' },
				d.a({ href : '#' }, '&laquo; Back to search').activate(function() {
					me.trigger('AffiliateAvailableRoomListWidget.back');
					return false;
				})
			),
			d.div({ className : 'searchHeader' },
				d.div({ className : 'searchHeaderItem searchTitle' }, 'Current search:'),
				d.div({ className : 'searchHeaderItem resultsCount' }, roomsCountLabel),
				d.div({ className : 'searchHeaderItem occupancy' }, occupancyLabel),
				d.div({ className : 'searchHeaderItem arrive' }, arriveLabel),
				d.div({ className : 'searchHeaderItem depart' }, departLabel)
			),
			d.div({ className : 'disclaimer' },
				'* All rates ' + currencyCode + ' | Average nightly rate per room' + (has_fee_disclaimer ? ' | Rate includes mandatory hotel fee' : '')
			),
			d.div({ className : 'roomList' },
				_.map(sorted_rooms, function(room) {

					room.rooms = _settings.roomsCount;
					room.occupants = _settings.searchCriteria.occupancy;
					room.hotel_name = _settings.epsAvail.hotelName;
					room.affiliate = 'EAN';
					room.name = room.roomName;
					room.GDSInfo = {countryCode: _settings.epsAvail.countryCode};
					room.deposit_required = room.deposits !== undefined;

					var bedNames = '';
					var bedNameArray = [];
					var selectButton = d.button({ className : 'selectRoom secondaryButton disabled', 'disabled': 'true', tabindex : 0 }, 'Select').activate(_handleSelectButtonClosure(room));

					//Find all available rate details
					var rateRefundable, rateCancelPenalties, rateNonrefundableDateRanges, ratePayDetails, ratePromoDescription, rateAmenities;
					if (room.merchant_of_record === 'property') {
						// for merchant of record property and non-refundable
						if (room.refundable === false) {
							if (room.cancel_penalties !== undefined) {
								rateRefundable = d.li('Cancel penalties non-refundable');
							} else {
								if (room.deposit_required === true) {
									rateRefundable = d.li('Deposits non-refundable');
								} else if (room.deposit_required === false) {
									rateRefundable = d.li('Non-refundable');
								}
							}
						}
					} else if (room.merchant_of_record === 'expedia') {
						// for merchant if property expedia
						if (room.refundable === false) {
							rateRefundable = d.li("Non-refundable");
						}
					}
					if (room.cancel_penalties !== undefined) {
						var earliestDate = new Date(room.cancel_penalties[0].start);
						for(var cancelIndex=0; cancelIndex < room.cancel_penalties.length; cancelIndex++) {
							var cancelObject = room.cancel_penalties[cancelIndex];
							var indexedCancelDate = new Date(cancelObject.start);
							if (indexedCancelDate < earliestDate) {
								earliestDate = indexedCancelDate;
							}
						}
						var cancelDate = (earliestDate).toDateString().split(" ");
						rateCancelPenalties = d.li("Free cancellation until " + cancelDate[1] + " " + cancelDate[2]);
					}
					if (room.nonrefundable_date_ranges !== undefined) {
						rateNonrefundableDateRanges = [];
						for(var rangeIndex = 0; rangeIndex < room.nonrefundable_date_ranges.length; rangeIndex++) {
							var rangeObject = room.nonrefundable_date_ranges[rangeIndex];
							var startDate = new Date(rangeObject.start).toDateString().split(" ");
							var endDate = new Date(rangeObject.end).toDateString().split(" ");
							rateNonrefundableDateRanges.push(d.li(
								'Nights from ' + startDate[1] + " " + parseInt(startDate[2]) + " to "
								+ endDate[1] + " " + parseInt(endDate[2]) + " are not refundable"
							));
						}
					}
					if (room.merchant_of_record === 'expedia' || (room.merchant_of_record === 'property' && room.refundable === false)) {
						ratePayDetails = d.li("Pay when booking");
					} else if (room.merchant_of_record === 'property' && room.refundable === true) {
						if (room.deposit_required === false) {
							ratePayDetails = d.li("Pay at time of stay");
						} else if (room.deposit_required === true) {
							ratePayDetails = d.li("Pay with deposit");
						}
					}
					if (room.promotions && room.promotions.deal) {
						if (room.promotions.deal.description !== undefined) {
							ratePromoDescription = d.li(room.promotions.deal.description);
						}
					}
					if (room.amenities !== undefined) {
						rateAmenities = [];
						for(var rateAmenity in room.amenities) {
							rateAmenities.push( d.li( room.amenities[rateAmenity].name) );
						}
					}
					var rateDetails = d.ul(
						rateRefundable,
						rateCancelPenalties,
						rateNonrefundableDateRanges,
						ratePayDetails,
						ratePromoDescription,
						rateAmenities
					);
					var bed_group_ids = Object.keys( room.bed_groups );
					if( bed_group_ids.length > 1) {
						bedNameArray[0] = d.option({value: 'none'}, "Select preferred bed type (not guaranteed)").attr('style', 'display:none');
						for(var index=0; index < bed_group_ids.length; index++){
							var bed = room.bed_groups[ bed_group_ids[ index ] ];
							if (bed.configuration !== undefined) {
								var name = bed.configuration[0].bedType;
								bedNameArray.push( d.option({value: bed.links.price_check.href}, name) );
							}
						}

						if (bedNameArray.length > 1) {
							bedNames = d.select({
								className : 'roomRequestSelect',
								onchange: function (_selected) {
									room.epsPriceCheckLink = _selected.currentTarget.value;
									if(room.epsPriceCheckLink !== 'none') {
										selectButton.removeClass('disabled').removeAttr('disabled', 'false');
									} else {
										selectButton.addClass('disabled').attr('disabled', 'true');
									}
								}
							}, bedNameArray );
						}
					} else if ( bed_group_ids.length === 1) {
						selectButton.removeClass('disabled').removeAttr('disabled', 'false');
						room.epsPriceCheckLink = room.bed_groups[ bed_group_ids[0] ].links.price_check.href;

						var single_bed_group = room.bed_groups[ bed_group_ids[0] ];
						var name = '';
						if (single_bed_group.configuration !== undefined) {
							for(var index=0; index < single_bed_group.configuration.length; index++){
								var config = single_bed_group.configuration[ index ];
								if (index>0){
									name += " and ";
								}
								name += config.bedType;
							}
							bedNames = d.div({ className : 'bedName' }, name);
						}
					} else { //This is already default behavior, but we'll add the else anyways for clarity
						bedNames = ''; //This means bedGroups is missing configs
					}

					return d.div({ className: 'availableRoom' },
						d.div({ className : 'avgRate' },
							d.span({className: 'currencySymbol'}, cf(room.avgRate).symbol),
							Math.ceil(room.avgRate + room.fees),
							d.span({ className : 'disclaimerMarker' }, '*')
						),
						d.div({ className : 'detailContainer' },
							d.div({ className : 'roomDetails' },
								d.div({ className : 'roomName' }, room.roomName),
								bedNames,
								d.a({ className : 'infoLink' }, 'View room info &raquo;').activate(_handleViewRoomInfoClick(room))
							),
							d.div({ className : 'rateDetails' },
								rateDetails
							)
						),
						d.div({ className : 'selectRoomColumn'},
							selectButton
						)
					);
				})
			)
		));
	};

}, {
	WUID : 'defaultAffiliateAvailableRoomListWidgetWUID',
	widgetName : 'AffiliateAvailableRoomListWidget',
	searchCriteria : { },
	occupancyLabels : [
		'No Occupancy',
		'Single Occupancy',
		'Double Occupancy',
		'Triple Occupancy',
		'Quad Occupancy'
	],
	roomsCount : 1,
	meetingInfo : {}
});
